import { DOCUMENT } from '@angular/common';
import { Component, OnInit, Inject,Input } from '@angular/core';
import { HomepageService } from '../../../services/homepage.service';
import { Ng5SliderModule, LabelType, Options } from 'ng5-slider';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SafeUrl } from '@angular/platform-browser';
import { CookieService } from 'ngx-cookie-service';
import { TenantService } from '../../../services/tenant.service';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit {

  constructor( private activatedRoute: ActivatedRoute, private cookieService: CookieService, private router: Router, private homepageService: HomepageService, @Inject(DOCUMENT) private document: Document, private tenantService: TenantService ) {
    this.tenant = this.tenantService.tenant;
  }
  @Input() public pageType: SafeUrl = 'inner'; 
  searchSetting: any = [];
  filtersMore: boolean = false;
  tenant: any;
  limitToSearch: boolean = false;

  minValueReading: number = 0;
  maxValueReading: number = 0;
  minValuePoint: number = 0;
  maxValuePoint: number = 0;
  
  searchType: string = '';
  searchFor: string = '';
  searchIn: string = '';
  searchInVal: string = '';
  exact: string = '';

  isActiveAll : string = 'active';  
  isActiveAuthor : string = '';  
  isActiveTitle : string = '';  
  isActiveSubject : string = '';  
  isActiveSeries : string = '';  
  limitToShow: boolean= false;
  limitToArray: any = {
    'availability': false,
    'category' : false,
    'lexile' : false,
    'lexileGrade' : false,
    'lexileCode' : false,
    'fountas' : false,
    'rc' : false,
    'ar' : false,
    'homeLocation' : false
  };
  advanceShow: boolean= false;
  isEXactTerm: boolean = false;
  autoSuggesstions: any = [];
  autoSuggesstionsStatus: boolean = false;
  isLogin: boolean = false;
  searchKeyWord: any;
  booleanBoxs: any[] = [{
    'term': '',
    'in': '',
    'operator': '0',
  }];
  options: Options = {
    floor: 0,
    ceil: 120
  };
  activeTab:any = '';
  locationSelected: any = '';
  advanceEnabled: boolean = false ;
  lateStart:any;
  timerTimeout:number = 5000;
  
  // Array of selectable option values in lowercase
  selectOptionLevels: string[] = [
    'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'z+'
  ];

  ngOnInit(){
    this.getsearchSetting();
    this.searchSetting = this.homepageService.getUpdatedConfig();
    if(this.searchSetting.data.settings.search.types.marc.enabled || this.searchSetting.data.settings.search.types.boolean.enabled || this.searchSetting.data.settings.search.types.barcode.enabled || this.searchSetting.data.settings.search.types.call.enabled || this.searchSetting.data.settings.search.types.lexile.enabled || this.searchSetting.data.settings.search.types.fountas.enabled || this.searchSetting.data.settings.search.types.rc.enabled || this.searchSetting.data.settings.search.types.ar.enabled)
      this.advanceEnabled = true;
    
    var key = 'selectedlocation'+this.searchSetting.data.tenantCode.toLowerCase();    
    this.locationSelected  = this.cookieService.get(key);
    this.activatedRoute.queryParams.subscribe(params => {
          this.searchType = params['type'];
          if(this.searchType == 'Basic'){
            this.searchFor = decodeURIComponent(params['keyword']);                   
            this.searchIn = params['searchin'];  
            this.exact = params['exact'];  
          }
    });

    if(this.searchIn == 'All'){
      this.isActiveAll = 'active';  
      this.isActiveAuthor = '';  
      this.isActiveTitle = '';  
      this.isActiveSubject = '';  
      this.isActiveSeries = '';   
    } else if(this.searchIn == 'A'){
      this.isActiveAll = '';  
      this.isActiveAuthor = 'active';  
      this.isActiveTitle = '';  
      this.isActiveSubject = '';  
      this.isActiveSeries = '';   
    } else if(this.searchIn == 'T'){
      this.isActiveAll = '';  
      this.isActiveAuthor = '';  
      this.isActiveTitle = 'active';  
      this.isActiveSubject = '';  
      this.isActiveSeries = '';   
    } else if(this.searchIn == 'S'){
      this.isActiveAll = '';  
      this.isActiveAuthor = '';  
      this.isActiveTitle = '';  
      this.isActiveSubject = 'active';  
      this.isActiveSeries = '';   
    } else if(this.searchIn == 'I'){
      this.isActiveAll = '';  
      this.isActiveAuthor = '';  
      this.isActiveTitle = '';  
      this.isActiveSubject = '';  
      this.isActiveSeries = 'active';   
    } 



  }


  ngAfterViewInit() {
    if(this.pageType == 'inner'){
      this.filtersMore = false;
    }
    this.makeFancySelect();    
    //$("#readingcountsLevelMin").spinner({min: 0, max: 10});
  }


  getsearchSetting(){
    this.searchSetting = this.homepageService.getUpdatedConfig();
      var count = 0;
      if( this.searchSetting.data.settings.search.types.ar.enabled === true){
         this.advanceShow = true;
         if(count == 0){ this.activeTab = 'ar'; count++;}
      }
      if( this.searchSetting.data.settings.search.types.barcode.enabled === true){
         this.advanceShow = true;
         if(count == 0){this.activeTab = 'barcode'; count++;} 
      }
      if( this.searchSetting.data.settings.search.types.boolean.enabled === true){
         this.advanceShow = true;
         if(count == 0){this.activeTab = 'boolean'; count++;} 
      }
      if( this.searchSetting.data.settings.search.types.call.enabled === true){
         this.advanceShow = true;
         if(count == 0){this.activeTab = 'call'; count++;} 
      }
      if( this.searchSetting.data.settings.search.types.lexile.enabled === true){
         this.advanceShow = true;
         if(count == 0){this.activeTab = 'lexile'; count++;} 
      }
      if( this.searchSetting.data.settings.search.types.marc.enabled === true){
         this.advanceShow = true;
         if(count == 0){this.activeTab = 'marc'; count++;} 
      }
      if( this.searchSetting.data.settings.search.types.rc.enabled === true){
         this.advanceShow = true;
         if(count == 0){this.activeTab = 'rc'; count++;} 
      } 
      if( this.searchSetting.data.settings.search.types.fountas.enabled === true){
        this.advanceShow = true;
        if (count == 0) { this.activeTab = 'fountas'; count++; }
      }

      if(this.searchSetting.data.settings.search.defaultSearch != null && this.searchSetting.data.settings.search.defaultSearch != 'basic'){
        //this.advanceShow = true;
        this.activeTab = this.searchSetting.data.settings.search.defaultSearch;
        this.filtersMore = true;
      }

      if( this.searchSetting.data.settings.search.limitTo.availability.enabled === true){
            this.limitToShow = true;
            this.limitToArray.availability = true;
          } 
          if( this.searchSetting.data.settings.search.limitTo.category.enabled === true){
            this.limitToShow = true;
            this.limitToArray.category = true;
          } 
          if( this.searchSetting.data.settings.search.limitTo.lexile.enabled === true){
            this.limitToShow = true;
            this.limitToArray.lexile;
          }
          if( this.searchSetting.data.settings.search.limitTo.lexileGrade.enabled === true){
            this.limitToShow = true;
            this.limitToArray.lexileGrade = true;;
          }
          if( this.searchSetting.data.settings.search.limitTo.lexileCode.enabled === true){
            this.limitToShow = true;
            this.limitToArray.lexileCode = true;;
          }
          if( this.searchSetting.data.settings.search.limitTo.fountas.enabled === true){
            this.limitToShow = true;
            this.limitToArray.fountas = true;
          }
          if( this.searchSetting.data.settings.search.limitTo.rc.enabled === true){
            this.limitToShow = true;
            this.limitToArray.rc = true;;
          }
          if( this.searchSetting.data.settings.search.limitTo.ar.enabled === true){
            this.limitToShow = true;
            this.limitToArray.ar= true;;
          }
          if( this.searchSetting.data.settings.search.limitTo.homeLocation.enabled === true){
            this.limitToShow = true;
            this.limitToArray.homeLocation = true;;
          }       
      }

   filtersMoreFn(event: any) {
    var auth = localStorage.getItem('token');
    if(this.cookieService.check('patronPermissions')){
      var permissions = JSON.parse(this.cookieService.get('patronPermissions'));
      if(typeof(auth) == 'string' && auth != null && permissions.opacAdmin){
        this.isLogin = true;
       } else {
          this.isLogin = false;
       }
    } else {
      this.isLogin = false;
    }
    if ($(event.target).hasClass('open')) {
      this.filtersMore = false; 
      $(event.target).removeClass('open');
    } else {
      this.filtersMore = true;
      $(event.target).addClass('open');
    }
    var self = this;
      
  }

  limitTo(event: any){

    if ($(event.target).hasClass('fas')) {
      if ($(event.target).parent().parent().hasClass('open')) {
          this.limitToSearch = false; 
         $(event.target).parent().parent().removeClass('open');
      } else {
        this.limitToSearch = true;
        $(event.target).parent().parent().addClass('open');
      }      
    } else {
      if($(event.target).hasClass('open')) {
          this.limitToSearch = false; 
         $(event.target).removeClass('open');
      } else {
        this.limitToSearch = true;
        $(event.target).addClass('open');
      }
    }
  }

  onKeyUp(type, event) {
    var $this = this;
    $('.search-main-input.show').removeClass('error');
    this.autoSuggesstions = [];
    $('#basicResourceId').val('');
    this.autoSuggesstionsStatus = false;
    this.searchKeyWord = (<HTMLInputElement>document.getElementById('serachInBasic')).value;
    if(this.searchSetting.data.settings.search.basicSearchIn.bigButtons){
            var searchin = this.searchInVal.toString();
          }else{
            var searchin = (<HTMLSelectElement>document.getElementById('serachInBasicIn')).value;
          }
    if(event.key == 'Enter' && event.keyCode ==13){
      event.preventDefault();
      if($.trim(this.searchKeyWord) != ''){
        var extract = false;      
        this.filtersMore  = false;
        $('#serachInBasic').val('');
        let searchObj = { type: 'Basic',keyword: encodeURIComponent(this.searchKeyWord),searchin: encodeURIComponent(searchin),exact:extract};
        if(this.cookieService.check('seachFor')){
          if(this.cookieService.get('seachFor')==this.searchKeyWord){
            searchObj['location']=this.cookieService.get('selectedlocation'+this.tenant);
          }
        }

        // console.log(this.searchKeyWord,'13');
        sessionStorage.setItem('lastSearchKeyword',this.searchKeyWord);
        
        this.router.navigate(['/searchlist'],{ queryParams: this.addLimitTo(searchObj)});
      }
      else
        $('.search-main-input.show').addClass('error');
    } else {
      if(this.searchSetting.data.settings.search.autoComplete.enabled && this.searchSetting.data.settings.search.autoComplete.minChars <= $.trim(this.searchKeyWord).length ){
        clearTimeout($this.lateStart);
        $this.lateStart = setTimeout(function(){
          //console.log('Test');
          $this.doSuggestionSearch(searchin);
          }, 1000);
      } else{
        this.autoSuggesstionsStatus = false;
        //$('#serachInBasicInSel').find('span[value=""]').trigger('click');
      }

    }
  }

  doSuggestionSearch(searchin){
    //var searchin = (<HTMLSelectElement>document.getElementById('serachInBasicIn')).value; 
    this.searchKeyWord = (<HTMLInputElement>document.getElementById('serachInBasic')).value;
    this.homepageService.autoCompleteSuggestion(this.searchKeyWord, searchin).subscribe(( data: any) => {
    this.autoSuggesstionsStatus = false;
    this.searchKeyWord = (<HTMLInputElement>document.getElementById('serachInBasic')).value;
      if($.trim(this.searchKeyWord) != '' &&  data.data.length > 0){
        this.autoSuggesstions = data.data;            
        this.autoSuggesstionsStatus = true;
      } else {           
        $('#serachInBasicInSel').find('span[value=""]').trigger('click');    
      }
    });
  }

  onSearchIcon() {
  //console.log($('body').find('#serachInBasic').val());
    this.autoSuggesstionsStatus = false;
     var resourceId = $('#basicResourceId').val();
     var searchKeyWord = $('body').find('#serachInBasic').val().toString();
      if($.trim(searchKeyWord) != ''){
        sessionStorage.setItem('lastSearchKeyword',this.searchKeyWord);
        var extract = false;
        if(this.searchSetting.data.settings.search.basicSearchIn.bigButtons){
            var searchin = this.searchInVal.toString();
          }else{
            var searchin = $('body').find('#serachInBasicIn').val().toString();
          }
        this.filtersMore  = false;
        $('#serachInBasic').val('');
        let searchObj = { type: 'Basic',keyword:searchKeyWord,searchin:searchin,exact:extract};
        if(this.cookieService.check('seachFor')){
          if(this.cookieService.get('seachFor')==searchKeyWord){
            searchObj['location']=this.cookieService.get('selectedlocation'+this.tenant);
          }
        }

        if(typeof(resourceId) == 'undefined' || resourceId == '') {
          resourceId = '';
          this.router.navigate(['/searchlist'],{ queryParams: this.addLimitTo(searchObj)});
        }else{
          this.router.navigate(['/searchlist'],{ queryParams: this.addLimitTo({ type: 'Basic',keyword:searchKeyWord,searchin:searchin,exact:extract,resource:resourceId})});
        } 
      }
    else
        $('.search-main-input.show').addClass('error');
  }

    changeRangeReading(value){
      this.minValueReading = value.value;
      this.maxValueReading = value.highValue;      
    }
    changeRangePoints(value){
      this.minValuePoint = value.value;
      this.maxValuePoint = value.highValue;
    }

    AcceleratedReaderSearch(){
      var searchLevel = (<HTMLSelectElement>document.getElementById('arInterestLevel'));
      var level = searchLevel.options[searchLevel.selectedIndex].value 
      var ar = (<HTMLSelectElement>document.getElementById('arReadingLevel')).value;
      var ar = (<HTMLSelectElement>document.getElementById('arReadingLevel')).value;
      this.filtersMore  = false;
       this.router.navigate(['/searchlist'],{ queryParams: this.addLimitTo({ type: 'ar',rmin:this.minValueReading,rmax:this.maxValueReading, pmin:this.minValuePoint, pmax:this.maxValuePoint, int: level }) }); 
       return; 
    }

    makeFancySelect(){
        var selectedLoc = this.locationSelected;
        $('.sel').each(function() {
          $(this).removeClass('close');
          $(this).children('select').css('display', 'none');
          var $current = $(this);
          $(this).find('option').each(function(i) {
            if(i == 0 && !$current.hasClass('location')) {
              $current.prepend($('<div>', {
                class: $current.attr('class').replace(/sel/g, 'sel__box')
              }));
              var placeholder = $(this).text();
              $current.prepend($('<span>', {
                class: $current.attr('class').replace(/sel/g, 'sel__placeholder'),
                text: placeholder,
                'data-placeholder': placeholder,
              }));
          } else if(i == 0 && $current.hasClass('location')) {
              $current.prepend($('<div>', {
                class: $current.attr('class').replace(/sel/g, 'sel__box')
              }));
              var placeholder = $(this).text();
              $current.prepend($('<span>', {
                class: $current.attr('class').replace(/sel/g, 'sel__placeholder'),
                text: placeholder,
                'data-placeholder': placeholder,
              }));
          } else if(i > 0 && $current.hasClass('location')) {
              var id = $(this).val();
              var placeholder = $(this).text();
              if(id == selectedLoc){
                var placeholder = $(this).text();
                $current.find('.sel__placeholder').text(placeholder).attr('data-placeholder', placeholder);   
              }
            }

          $current.children('div').append($('<span>', {
            class: $current.attr('class').replace(/sel/g, 'sel__box__options'),
            text: $(this).text(),
            'value': $(this).val(),      
          }));
        });
      });

      // Toggling the `.active` state on the `.sel`.
      $('.sel').click(function(event) {
        if(event.target.nodeName != 'SELECT' && event.target.nodeName != 'select'){
          $(this).toggleClass('active');
        }
      });

      // Toggling the `.selected` state on the options.
      $('.sel__box__options').click(function() {
        var txt = $(this).text();
        var vals = $(this).attr('value');
        var index = $(this).index();      
        $(this).siblings('.sel__box__options').removeClass('selected');
        $(this).addClass('selected');  
        var $currentSel = $(this).closest('.sel');
        $currentSel.children('.sel__placeholder').text(txt);
        $currentSel.children('select').find('option[value="'+vals+'"]').prop('selected',true);
        $currentSel.children('select').click();
      });
    }
    advanceSearch(event) {
      if(event.type == 'keyup' && event.key != 'Enter'){
        return false;
      }

      var activeSeach = $('.advanced-form').find('.tab-pane.active').find('input.searchType').val();
      $('.sel').removeClass('active');

      if(activeSeach == 'Marc'){
        var term = (<HTMLInputElement>document.getElementById('serachInMarc')).value;
        var extract = (<HTMLInputElement>document.getElementById('startWithMarc')).checked;
        if($.trim(term) != ''){           
            var searchIn = (<HTMLSelectElement>document.getElementById('serachInMarcIn')).value;
              this.filtersMore  = false;
            this.router.navigate(['/searchlist'],{ queryParams: this.addLimitTo({ type: activeSeach,keyword: term,searchin:searchIn,exact:extract }) });
        } else {
          $('#serachInMarc').addClass('error');
        }
      }
      else if(activeSeach == 'Call') {
        var start = (<HTMLInputElement>document.getElementById('callStart')).value;
        var end = (<HTMLInputElement>document.getElementById('callEnd')).value;
        if($.trim(start) == ''){
          $('#callStart').addClass('error');
        }
        if($.trim(start) != ''){
            var extract = false;
              this.filtersMore  = false;
            this.router.navigate(['/searchlist'],{ queryParams: this.addLimitTo({ type: activeSeach,start: start,end:end,exact:extract }) });
        }
      }
      else if(activeSeach == 'Barcode') {
        var start = (<HTMLInputElement>document.getElementById('barcodeStart')).value;
        if($.trim(start) == ''){
          $('#barcodeStart').addClass('error');
        }
        var end = (<HTMLInputElement>document.getElementById('barcodeEnd')).value;        
        if($.trim(start) != ''){
            var extract = false;       
            this.filtersMore  = false;
            this.router.navigate(['/searchlist'], { queryParams: this.addLimitTo({ type: activeSeach,start: start,end:end,exact:extract }) });
        }
      }
      else if(activeSeach == 'ReadingCounts') {
        var LevelMin = (<HTMLInputElement>document.getElementById('readingcountsLevelMin')).value;
        var LevelMax = (<HTMLInputElement>document.getElementById('readingcountsLevelMax')).value;
        var PointMin = (<HTMLInputElement>document.getElementById('readingcountsPointMin')).value;
        var PointMax = (<HTMLInputElement>document.getElementById('readingcountsPointMax')).value;
        if($.trim(LevelMin) != '' && $.trim(LevelMax) != '' && $.trim(PointMin) != '' && $.trim(PointMax) != '' ){
            var extract = false;       
              this.filtersMore  = false;      
            this.router.navigate(['/searchlist'], { queryParams: this.addLimitTo({ type: activeSeach,levelmin: LevelMin,levelmax:LevelMax,pointmin: PointMin,pointmax:PointMax,exact:extract }) });
        } else {
          if($.trim(LevelMin) == ''){
              $('#readingcountsLevelMin').addClass('error');
          }
          if($.trim(LevelMax) == ''){
              $('#readingcountsLevelMax').addClass('error');
          }
          if($.trim(PointMin) == ''){
              $('#readingcountsPointMin').addClass('error');
          }
          if($.trim(PointMax) == ''){
              $('#readingcountsPointMax').addClass('error');
          }
        }
      }
      else if (activeSeach == 'Fountas') {
        var LevelMin = (<HTMLSelectElement>document.getElementById('fountasLevelMin')).value;
        var LevelMax = (<HTMLSelectElement>document.getElementById('fountasLevelMax')).value;
        if ($.trim(LevelMin) != '' && $.trim(LevelMax) != '') {
          var extract = false;
          this.filtersMore = false;
          this.router.navigate(['/searchlist'], { queryParams: this.addLimitTo({ type: activeSeach, levelmin: LevelMin, levelmax: LevelMax, exact: extract }) });
        } else {
          if ($.trim(LevelMin) == '') {
            $('#fountasLevelMin').addClass('error');
          }
          if ($.trim(LevelMax) == '') {
            $('#fountasLevelMax').addClass('error');
          }
        }
      }
      else if(activeSeach == 'AcceleratedReader') {
        var LevelMin = (<HTMLInputElement>document.getElementById('AcceleratedReaderLevelMin')).value;
        var LevelMax = (<HTMLInputElement>document.getElementById('AcceleratedReaderLevelMax')).value;
        var PointMin = (<HTMLInputElement>document.getElementById('AcceleratedReaderPointsMin')).value;
        var PointMax = (<HTMLInputElement>document.getElementById('AcceleratedReaderPointsMax')).value;
        var InterestLevel = (<HTMLSelectElement>document.getElementById('AcceleratedReaderInterestLevel')).value;
        if(($.trim(LevelMin) != '' && $.trim(LevelMax) != '') || ($.trim(PointMin) != '' && $.trim(PointMax) != '')){            
          this.filtersMore  = false;
          //this.addLimitTo({ type: activeSeach,levelmin: LevelMin,levelmax:LevelMax,pointmin: PointMin,pointmax:PointMax,int:InterestLevel })
          this.router.navigate(['/searchlist'],{ queryParams: this.addLimitTo({ type: activeSeach,levelmin: LevelMin,levelmax:LevelMax,pointmin: PointMin,pointmax:PointMax,int:InterestLevel }) });
        } else {
          if($.trim(LevelMin) == ''){
            $('#AcceleratedReaderLevelMin').addClass('error');
          }
          if($.trim(LevelMax) == ''){
            $('#AcceleratedReaderLevelMax').addClass('error');
          }
          if($.trim(PointMin) == ''){
            $('#AcceleratedReaderPointsMin').addClass('error');
          }
          if($.trim(PointMax) == '' ){
            $('#AcceleratedReaderPointsMax').addClass('error');
          }
        }
      }
      else if(activeSeach == 'Lexile') {
        var LevelMin = (<HTMLInputElement>document.getElementById('LexileLevelMin')).value;
        var LevelMax = (<HTMLInputElement>document.getElementById('LexileLevelMax')).value;        
        var Lexilecode = (<HTMLSelectElement>document.getElementById('Lexilecode')).value;
        var LexilePatronType = (<HTMLSelectElement>document.getElementById('LexilePatronType')).value;
        if($.trim(LevelMin) != '' && $.trim(LevelMax) != ''){
            this.filtersMore  = false;
            this.router.navigate(['/searchlist'],{ queryParams: this.addLimitTo({ type: activeSeach,levelmin: LevelMin,levelmax:LevelMax,code: Lexilecode,patronType:LexilePatronType }) });
        } else {
          if($.trim(LevelMin) == ''){
            $('#LexileLevelMin').addClass('error');
          }
          if($.trim(LevelMax) == ''){
            $('#LexileLevelMax').addClass('error');
          }
        }
      }
      else if(activeSeach == 'Boolean') {
        var boxCount = 0;
        var apiString = '';
        var error = 0;
        var tempOprand = 'AND';
        $('div#nav-Boolean').find('.boxBoolean').each(function(){
          $(this).find('input[name="terms"]').removeClass('error');
          var terms = $.trim($(this).find('input[name="terms"]').val().toString());
          if(terms != ''){
            var searchIn = $(this).find('select[name="searchIn"]').val();
            var operand = $(this).find('ul.booleanOpretors li.active').text();
            boxCount++;            
            if(boxCount != 0){
              apiString +='&';
            }
            if(boxCount == 1){
              tempOprand = 'AND';             
              apiString += 'term-'+boxCount+'='+terms+'&in-'+boxCount+'='+searchIn+'&op-'+boxCount+'='+tempOprand; 
            } else {
              apiString += 'term-'+boxCount+'='+terms+'&op-'+boxCount+'='+operand+'&in-'+boxCount+'='+searchIn;
            }            
          } else {
              $(this).find('input[name="terms"]').addClass('error');
              error++;
            }
        });

        if(boxCount != 0 && error == 0){
          this.filtersMore  = false;
          apiString += '&count='+boxCount;    
          let a = this.addLimitTo({ type: activeSeach,parameters: apiString });
          this.router.navigate(['/searchlist'],{ queryParams: { type: a.type,parameters: a.parameters } });     
        }
      } else if(activeSeach == 'PopularTitles') {
        var error:number = 0;
        var Period = (<HTMLInputElement>document.getElementById('populartitlesPeriod')).value;
        var Size = (<HTMLInputElement>document.getElementById('populartitlesSize')).value;  
        var published: boolean = $('#populartitlesPublish').is(':checked');
        if($.trim(Period) == ''){
          $('#populartitlesPeriod').addClass('error');
          error++;
        }
        if($.trim(Period) == ''){
          $('#populartitlesPeriod').addClass('populartitlesSize');
          error++;
        }
        if(error != 0){
          return false;
        }
        this.filtersMore  = false;
        this.router.navigate(['/searchlist'],{ queryParams: this.addLimitTo({ type: activeSeach,period: Period, size : Size,publish: published  }) });
      } else if(activeSeach == 'NewInLibrary') {
        var error:number = 0;
        var Period = (<HTMLInputElement>document.getElementById('newinlibraryPeriod')).value;
        //var Size = (<HTMLInputElement>document.getElementById('newinlibrarySize')).value;  
        var published: boolean = $('#newinlibraryPublish').is(':checked');
        var copies: boolean = $('#newinlibraryCopies').is(':checked');
        if($.trim(Period) == '') {
          $('#populartitlesPeriod').addClass('error');
          error++;
        }
        if($.trim(Period) == ''){
          $('#populartitlesPeriod').addClass('populartitlesSize');
          error++;
        }
        if(error != 0){
          return false;
        }
        this.filtersMore  = false;
        this.router.navigate(['/searchlist'],{ queryParams: this.addLimitTo({ type: activeSeach,period: Period, publish: published,copies: copies  }) });
      }
    }

    validateSearch(event, searchType, fieldType){
      $(event.target).parent().find('.errorMessage').remove();
      let inputValue = $.trim($(event.target).val().toString());
      let min   = $(event.target).attr('min');
      let max   = $(event.target).attr('max');    
      let steps = $(event.target).attr('step');
      let group = $(event.target).attr('group');    
    if(searchType != 'Lexile'){  
        /* Add Zero to the float vaue if not have */
        if(inputValue.indexOf('.') >= 0){
          var checkFlt = inputValue.split('.');
          if(checkFlt[0] == ''){
            inputValue = '0'+inputValue;
            $(event.target).val(inputValue);
          }
        }
        
        /* Set minimum and maximum  values if less and greater to range*/
        if(parseFloat(inputValue) > parseFloat(max) || parseFloat(inputValue) < parseFloat(min) ){
          if(typeof($(event.target).attr('ismin')) != 'undefined'){
            $(event.target).val(min).removeClass('error');
            $(event.target).parent().append('<span class="errorMessage">Enter value between '+min+' to '+max+'</span>');
          } else {
            $(event.target).val(max).removeClass('error');
            $(event.target).parent().append('<span class="errorMessage">Enter value between '+min+' to '+max+'</span>');
          }
          setTimeout(function(){
            $(event.target).focus().removeClass('error');
          },10);
        } else {
          if(typeof($(event.target).attr('ismin')) != 'undefined'){
            var MaxValue = $.trim($('input#'+group+'Max').val().toString());
            if(MaxValue != '' && (parseFloat(MaxValue) <  parseFloat(inputValue)))
            {
              $(event.target).val(min).removeClass('error');  
              return false;
            }
          } else {
            var MinValue = $.trim($('input#'+group+'Min').val().toString());            
            if(MinValue != '' && (parseFloat(MinValue) >  parseFloat(inputValue)) )
            {
              $(event.target).val(max).removeClass('error'); 
              $(event.target).parent().append('<span class="errorMessage">Enter value between '+min+' to '+max+'</span>'); 
              return false;
            }
          }
          /* Check for values in case of step 0.5 */
          if(steps == '0.5'){
            var near = this.nearest(inputValue).toString();  
            if(near.indexOf('.') == -1 && near != '0'){
              $(event.target).val(near+'.0').removeClass('error');               
              $(event.target).val(near).removeClass('error');             
            }    
          }
        }
        if(searchType == 'AcceleratedReader' && parseFloat(inputValue) > 0){
          var LevelMin = (<HTMLInputElement>document.getElementById('AcceleratedReaderLevelMin')).value;
          var LevelMax = (<HTMLInputElement>document.getElementById('AcceleratedReaderLevelMax')).value;
          var PointMin = (<HTMLInputElement>document.getElementById('AcceleratedReaderPointsMin')).value;
          var PointMax = (<HTMLInputElement>document.getElementById('AcceleratedReaderPointsMax')).value;
          if(parseFloat(LevelMin) > 0 && parseFloat(LevelMax) > 0 && PointMin == '' && PointMax == ''){
            $('#AcceleratedReaderPointsMin').removeClass('error');
            $('#AcceleratedReaderPointsMax').removeClass('error');
          }else if(parseFloat(PointMin) > 0 && parseFloat(PointMax) > 0 && LevelMin == '' && LevelMax == ''){
            $('#AcceleratedReaderLevelMin').removeClass('error');
            $('#AcceleratedReaderLevelMax').removeClass('error');
          }
          if(fieldType == 'LevelMin'){
            $('#AcceleratedReaderLevelMin').removeClass('error');
          }
          if(fieldType == 'LevelMax'){
            $('#AcceleratedReaderLevelMax').removeClass('error');
          }
          if(fieldType == 'PointMin'){
            $('#AcceleratedReaderPointsMin').removeClass('error');
          }
          if(fieldType == 'PointMax' ){
            $('#AcceleratedReaderPointsMax').removeClass('error');
          }
        }
      } else {
         $(event.target).removeClass('error');  
         if(parseFloat(inputValue) > parseFloat(max) || parseFloat(inputValue) < parseFloat(min) ){
          if(typeof($(event.target).attr('ismin')) != 'undefined'){
            $(event.target).val(min).removeClass('error');
             $(event.target).parent().append('<span class="errorMessage">Enter value between '+min+' to '+max+'</span>');
          } else {
            $(event.target).val(max).removeClass('error');
             $(event.target).parent().append('<span class="errorMessage">Enter value between '+min+' to '+max+'</span>');
          }        
          setTimeout(function(){
            $(event.target).focus().removeClass('error');            
          },10);
        } else if(typeof($(event.target).attr('ismin')) != 'undefined'){
            var MaxValue = $.trim($('input#'+group+'Max').val().toString());            
            if(MaxValue != '' && (parseFloat(MaxValue) <  parseFloat(inputValue)))
            {
              $(event.target).val(min).removeClass('error');  
               $(event.target).parent().append('<span class="errorMessage">Enter value between '+min+' to '+max+'</span>');
              return false;
            }
          } else {
            var MinValue = $.trim($('input#'+group+'Min').val().toString());            
            if(MinValue != '' && (parseFloat(MinValue) >  parseFloat(inputValue)) )
            {
              $(event.target).val(max).removeClass('error');  
               $(event.target).parent().append('<span class="errorMessage">Enter value between '+min+' to '+max+'</span>');
              return false;
            }
          }
      }

    setTimeout(function(){
       $(event.target).parent().find('.errorMessage').remove();
      },10000);
    }

    nearest(value) {
      return (Math.round(value*2)/2);
    }

    selectOpretor(event){
      $(event.target).parent().find('li').removeClass('active');
      $(event.target).addClass('active');
    }

    copyOpretorBox(event){
      var index = $(event.target).index();
      this.booleanBoxs.push({'term': '','in': '','operator': index});    
    }
    removeOpretorBox(event){
      var ind = $(event.target).parents('.row').index();
      this.booleanBoxs.splice( (ind - 1), 1);
    }

    lexileGradeChange(event){
      $('input#LexileLevelMin').val($(event.target).find('option:selected').attr('min'));
      $('input#LexileLevelMax').val($(event.target).find('option:selected').attr('high'));
      $('select#Lexilecode').find('option:eq(0)').prop('selected',true);
    }

    manageExactTerm(event){
      this.isEXactTerm = event.target.value;
    }

    setAuthor(type, event){
      $('.search-main-thumbnails').find('button').removeClass('active');
      this.searchInVal = type;
      if(event.target.nodeName == 'BUTTON'){
        $(event.target).addClass('active');
      $('#serachInBasicIn').find('option[value="'+type+'"]').prop('selected',true);
      } else {
        $(event.target).parents('button').addClass('active');
      }      
      $('#serachInBasicIn').click();
    }

    autocompleteSelect(event){
      $('ul.autoSuggesstionsUl').find('li').removeClass('selected');
      if(event.target.nodeName.toLowerCase() == 'li'){
        $('#basicResourceId').val($(event.target).attr('id'));        
      } else {
        $('#basicResourceId').val($(event.target).parents('li').attr('id'));
      }
      this.autoSuggesstionsStatus = false;
      this.onSearchIcon();
    }

    onKeyDown(event){
    var $this = this;
    //console.log('clear');
    clearTimeout($this.lateStart);
      if(event.key == 'Enter' && event.keyCode ==13){
        event.preventDefault();
      }
    }

   
addLimitTo(object){
  var objectTemp = {};
  $('input.checkLimit').each(function(this){
    //console.log($(this).attr('name'));
    if($(this).is(':checked') && $(this).attr('name') == 'limitCategory'){
      if(object.type == 'Boolean'){
        object['parameters'] += '&l-cat=' + $('#l-cat').val();
      }
      else{
        object['l-cat'] = $('#l-cat').val();
      }
    }
    if($(this).is(':checked') && $(this).attr('name') == 'limitInlib'){
      if(object.type == 'Boolean'){
        object['parameters'] += '&l-inlib='+ $(this).is(':checked');
      }
      else{
        object['l-inlib'] = $(this).is(':checked');
      }
    }
    if($(this).is(':checked') && $(this).attr('name') == 'limitLexile'){
      if(object.type == 'Boolean'){
        object['parameters'] += '&l-lexmin='+$('input[name=l-lexmin]').val();
        object['parameters'] += '&l-lexmax='+$('input[name=l-lexmin]').val();
        if(typeof($('select[name=l-lexcode]').val()) != 'undefined'){
          object['parameters'] += '&l-lexcode='+$('select[name=l-lexcode]').val();  
        }
        if(typeof($('select[name=l-lexpat]').val()) != 'undefined'){
          object['parameters'] += '&l-lexpat='+ $('select[name=l-lexpat]').val();
        }
      }else{
        object['l-lexmin'] = $('input[name=l-lexmin]').val();
        object['l-lexmax'] = $('input[name=l-lexmin]').val();
        if(typeof($('select[name=l-lexcode]').val()) != 'undefined'){
          object['l-lexcode'] = $('select[name=l-lexcode]').val();  
        }
        if(typeof($('select[name=l-lexpat]').val()) != 'undefined'){
          object['l-lexpat'] = $('select[name=l-lexpat]').val();
        }
      }
    }
    if($(this).is(':checked') && $(this).attr('name') == 'limitFountas'){
      if(object.type == 'Boolean'){
        object['parameters'] += '&l-fpmin=' + $('#l-fpmin').val();
        object['parameters'] += '&l-fpmax=' + $('#l-fpmax').val();
      }else{
        object['l-fpmin'] = $('#l-fpmin').val();
        object['l-fpmax'] = $('#l-fpmax').val();
      }
    }
    if($(this).is(':checked') && $(this).attr('name') == 'limitReading'){
      if(object.type == 'Boolean'){
        object['parameters'] += '&l-rcmin' + $('input[name=l-rcmin]').val();
        object['parameters'] += '&l-rcmax' + $('input[name=l-rcmax]').val();
        object['parameters'] += '&l-rcminpt' + $('input[name=l-rcminpt]').val();
        object['parameters'] += '&l-rcmaxpt' + $('input[name=l-rcmaxpt]').val();
      }else{
        object['l-rcmin'] = $('input[name=l-rcmin]').val();
        object['l-rcmax'] = $('input[name=l-rcmax]').val();
        object['l-rcminpt'] = $('input[name=l-rcminpt]').val();
        object['l-rcmaxpt'] = $('input[name=l-rcmaxpt]').val();
      }
    }
    if($(this).is(':checked') && $(this).attr('name') == 'limitAccelerated'){
      if(object.type == 'Boolean'){
        object['parameters'] += '&l-armin=' + $('input[name=l-armin]').val();
        object['parameters'] += '&l-armax=' + $('input[name=l-armax]').val();
        object['parameters'] += '&l-arminpt=' + $('input[name=l-arminpt]').val();
        object['parameters'] += '&l-armaxpt=' + $('input[name=l-armaxpt]').val();
        object['parameters'] += '&l-arint=' + $('select[name=l-arint]').val();
      }else{
        object['l-armin'] = $('input[name=l-armin]').val();
        object['l-armax'] = $('input[name=l-armax]').val();
        object['l-arminpt'] = $('input[name=l-arminpt]').val();
        object['l-armaxpt'] = $('input[name=l-armaxpt]').val();
        object['l-arint'] = $('select[name=l-arint]').val();
      }
    }
  });
  return object;
}



}
